import { io } from 'socket.io-client';
import { API_BASE_URL } from './config/api';

// Otomatik bağlanmasın, login olunca bağlayacağız.
export const socket = io(API_BASE_URL, {
  autoConnect: false,
  withCredentials: true,
});

// Socket.io odaları socket başına tutulur. Bağlantı koptuğunda (ağ dalgalanması,
// backend yeniden başlatma) client otomatik yeniden bağlanır ama sunucu tarafında
// bu YENİ bir socket'tir ve hiçbir odada değildir. Katılım tek seferlik yapılırsa
// yeniden bağlanmadan sonra `ml:job:*`, `stats:job:*`, `excel:import:*` event'leri
// sessizce gelmemeye başlar. Bu yüzden katılınacak doktor kimliğini saklıyor ve
// her 'connect' olayında odalara tekrar katılıyoruz.
let joinedDoctorId = null;

socket.on('connect', () => {
  if (joinedDoctorId) socket.emit('join_team', joinedDoctorId);
});

socket.on('connect_error', (err) => {
  if (err?.message === 'SOCKET_AUTH_REQUIRED' || err?.message === 'SOCKET_AUTH_INVALID') {
    console.warn('[socket] Kimlik doğrulama hatası:', err.message);
  }
});

/**
 * Socket'i bağlar ve doktorun ekip odalarına katılır.
 * Birden fazla kez çağrılması güvenlidir (sunucuda `join` idempotenttir).
 * @param {string} [doctorId] - Odalara katılacak doktor kimliği.
 */
export function connectSocket(doctorId) {
  if (doctorId) joinedDoctorId = doctorId;
  if (!socket.connected) {
    socket.connect(); // odalara katılım 'connect' handler'ında yapılır
    return;
  }
  if (joinedDoctorId) socket.emit('join_team', joinedDoctorId);
}

/**
 * Oturum kapanırken çağrılır. Kayıtlı doktor kimliğini temizler ve bağlantıyı
 * kapatır; aksi hâlde aynı tarayıcıda başka bir hesapla girildiğinde eski
 * doktorun odalarından event almaya devam edilir.
 */
export function disconnectSocket() {
  joinedDoctorId = null;
  socket.auth = {};
  if (socket.connected) socket.disconnect();
}
